var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.$vuetify.dark?'background-color: rgb(241, 241, 241)':'')},[(!_vm.print)?_c('navbar'):_vm._e(),_c('v-main',[_c('transition',{attrs:{"name":"scale","mode":"out-in"}},[_c('router-view')],1),_c('notification')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }